<app-dialog [showCloseButton]="false">
	<ng-container title>
		{{ 'common.session-dialog.title' | translate }}
	</ng-container>

	<ng-container content>
		<div>{{ 'common.session-dialog.warning' | translate }}</div>
	</ng-container>

	<ng-container actions>
		<button mat-flat-button mat-dialog-close color="primary" (click)="keepSessionAlive()">
			{{ 'common.session-dialog.extend' | translate }}
		</button>
	</ng-container>
</app-dialog>
